
import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie"; 
import LocalManager from "../../../class/LocalManager";
import loadingGif from "../static/img/loading-slider.gif";





const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;


function SliderV1({ sliderType, isLogged, handleOpenRegisterModal,lang }) {
  const [sliderData, setSliderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null); // Вибрана мова
  const carouselRef = useRef(null);
  const [carouselDimensions, setCarouselDimensions] = useState({ width: "100%", height: "100px" });

  const slide = {
    slides: [
      {
        img: "/assets/img/carousel1.jpg",
        inputs: [
          { lang_code: "zh", sub_title: "", title: "" },
          { lang_code: "en", sub_title: "", title: "" },
          { lang_code: "de", sub_title: "", title: "" },
          { lang_code: "it", sub_title: "", title: "" },
          { lang_code: "es", sub_title: "", title: "" },
        ],
        link: null,
        position: 1,
      },
      {
        img: "/assets/img/carousel2.jpg",
        inputs: [
          { lang_code: "zh", sub_title: "", title: "" },
          { lang_code: "en", sub_title: "", title: "" },
          { lang_code: "de", sub_title: "", title: "" },
          { lang_code: "it", sub_title: "", title: "" },
          { lang_code: "es", sub_title: "", title: "" },
        ],
        link: null,
        position: 2,
      },
      {
        img: "/assets/img/carousel3.jpg",
        inputs: [
          { lang_code: "zh", sub_title: "", title: "" },
          { lang_code: "en", sub_title: "", title: "" },
          { lang_code: "de", sub_title: "", title: "" },
          { lang_code: "it", sub_title: "", title: "" },
          { lang_code: "es", sub_title: "", title: "" },
        ],
        link: null,
        position: 3,
      },
    ],
    type: "Home",
  };

  useEffect(() => {
    // Отримання мови з кукі або використання дефолтної мови
    const savedLanguage = Cookies.get("lang");
    
    setSelectedLanguage(savedLanguage); 
  }, []);

  useEffect(() => {
    const fetchSliderData = async () => {
      setLoading(true);
      try {
        // Викликаємо метод з LocalManager
        // const data = await LocalManager.getSlider(sliderType);

        // if (data.status) {
        //   setSliderData(data.slider);
        // } else {
        //   setError(data.error || "Failed to load slider");
        // }

        setSliderData(slide);

      } catch (err) {
        console.error("Fetch error:", err);
        setError("Unexpected response format or server error");
      } finally {
        setLoading(false);
      }
    };

    fetchSliderData();
  }, [sliderType, lang]);

  useEffect(() => {
    if (carouselRef.current && sliderData) {
      const bootstrap = require("bootstrap");
      new bootstrap.Carousel(carouselRef.current, {
        interval: 8000,
        ride: "carousel",
      });
    }
  }, [sliderData]);

  useEffect(() => {
    const updateDimensions = () => {
      if (carouselRef.current) {
        const { offsetWidth, offsetHeight } = carouselRef.current.querySelector(".carousel-inner");
        setCarouselDimensions({ width: offsetWidth, height: offsetHeight });
      }
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);
  
  const LoaderSlide = () => (
    <div
      className="carousel-item active"
      style={{
        width: "100%",
        minHeight: "200px",
        backgroundColor: "#f3f3f3",
        backgroundImage: 'url("/assets/img/loading-slider.gif")', 
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        filter: "blur(1px)",
      }}
    ></div>
  );

  if (loading) {
    return (
      <div id={`carousel${sliderType}Controls`} className="carousel slide big-slider" ref={carouselRef}>
        <div className="carousel-inner">
          {Array.from({ length: 3 }).map((_, index) => (
            <LoaderSlide key={index} />
          ))}
        </div>
      </div>
    );
  }


  if (error) return <p>{error}</p>;
  if (!sliderData || !sliderData.slides || sliderData.slides.length === 0)
    return <p>No slides available.</p>;

  return (
    <div id={`carousel${sliderType}Controls`} className="carousel slide big-slider" ref={carouselRef}>
      <div className="carousel-inner">
      {sliderData.slides
        .sort((a, b) => a.position - b.position) // Сортування за параметром position
        .map((slide, index) => (
          <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
            <img
              // src={`${cmsUrl}${slide.img}`}
              src={`${slide.img}`}
              className="d-block w-100"
              alt={`Slide ${index + 1}`}
            />
            <div className="text-slider" style={{display:"none"}}>
              {slide.inputs
                .filter((input) => input.lang_code === lang) // Відображаємо тільки для обраної мови
                .map((input, inputIndex) => (
                  <div key={inputIndex}>
                    <h2>{input.title}</h2>
                    <p>{input.sub_title}</p>
                  </div>
                ))}
              
                {/* <div className="bt-slide">
                  
                  {index === 0 && !isLogged && (
                  <a
                    href="#"
                    className="btn btn-sm btn-registration"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpenRegisterModal();
                    }}
                  >
                    Registrati
                  </a>
                )}
                  {slide.link && (
                  <a
                    href={slide.link}
                    className="btn btn-sm btn-more"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Scopri
                  </a>
                )}
                </div> */}
              
            </div>
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselHomeControls"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselHomeControls"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}

export default SliderV1;






